<div class="container-sm">
  <div class="container-fluid pt-4">
    <div class="row">
      <div class="col-wm-12">
        <div class="wizard-area">
          <div
            class="wizard-container"
            routerLink="{{ navList.path }}"
            *ngFor="let navList of navListDetails"
          >
            <a class="{{ navList.navClassName }}">
              <span class="icon-style">
                <img src="{{ navList.iconSrc }}" />
              </span>
              <p class="wizard-name">{{ navList.navname }}</p>
            </a>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>


